import React, {Component} from 'react';
import {Buffer} from "buffer";
import MainLayout from "../../components/layouts/MainLayout";
import {withRouter} from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";
import {offerGeneralApiService} from "../../services/offer/OfferGeneralApiService";
import type {MenuProps} from 'antd'
import {Button, DatePicker, Dropdown, Form, Input, Menu, message, Modal, Select, Table, Tag, Tooltip} from 'antd';
import {CheckCircleTwoTone, CopyOutlined, DownOutlined, EditOutlined, ScheduleOutlined, SearchOutlined, SolutionOutlined, ThunderboltOutlined, WarningOutlined} from "@ant-design/icons";
import {ListGeneralOfferStates} from "./types/ListGeneralOfferTypes";
import moment from "moment";
import AreaGroupCitySelect from "../../components/area/AreaGroupCitySelect";
import Cookies from "universal-cookie";
import DetailOrder from "../../components/order/DetailOrder";
import UpdateOwnerOffer from "../../components/offer/UpdateOwnerOffer";
import UpdatePhoneNumber from "../../components/offer/UpdatePhoneNumber";
import currencyFormat from "../../helper/currencyFormat";
import UpdateGeneralOffer from "../../components/offer/UpdateGeneralOffer";
import DetailGeneralOffer from "../../components/offer/DetailGeneralOffer";
import UpdateDocumentGeneralOffer from "../../components/offer/UpdateDocumentGeneralOffer";
import QcLoan from "../../components/offer/QcLoan";

export interface ListGeneralOfferProps {
}

class ListGeneralOffer extends Component<ListGeneralOfferProps & any, ListGeneralOfferStates> {
    private readonly initState!: ListGeneralOfferStates;
    private user = JSON.parse(Buffer.from(new Cookies().get('_u'), "base64").toString());
    private accessLevel = ((cookieValue) => cookieValue ? JSON.parse(Buffer.from(cookieValue, "base64").toString()) : "")(new Cookies().get('_l'));
    private uDealer = JSON.parse(Buffer.from(new Cookies().get('_d'), "base64").toString());
    private token = new Cookies().get('_t');
    private tableColumn: any = [
        {
            title: 'Kode Offer',
            dataIndex: 'transaction_code',
            width: 220,
            render: ((value: string, row: any) => {
                return (
                    <React.Fragment>
                        <span style={(row?.qc_status) ? {} : {display: 'none'}}><Tooltip title={`Sudah dilakukan QC`} color={'green'}><CheckCircleTwoTone twoToneColor="#52c41a"/> &nbsp;</Tooltip></span>
                        <span className={`font-90-link`} onClick={() => this.setState({chosenOfferCode: row.transaction_code, chosenOfferRow: row, showModalDetailOffer: true})}>{value}</span>&nbsp;
                        <Tooltip title="Click untuk copy kode offer" color={'cyan'}><CopyOutlined className={'small-avatar-link'} onClick={event => this.copyToClipboard(value)}/></Tooltip>
                        <br/><span style={{fontSize: "80%"}}>{row?.type}</span>
                        <span style={!row.order_code ? {display: 'none'} : {fontSize: '60%'}}>
                            <br/><span style={{cursor: "pointer"}} onClick={event => this.showDetailOrder(row.order_code)}>{row.order_code}</span>
                        </span>
                        <div style={(this.state.filterOfferStatus?.toLowerCase() === 'open' && this.state.filterCityGroupCode) ? {} : {display: 'none'}}>
                            <span style={{fontSize: "80%"}}>available: {row?.additional_stock ?? "-"} | payment: {currencyFormat(row?.additional_paid) ?? "-"} </span>
                            <span style={row.additionalOrderPolicy ? {display: 'none'} : {}}>
                                <Tooltip title={`Minimum Kebijakan Order ${currencyFormat(row?.additionalOrderPolicyMinimumPaid)}`} color={'orange'}>
                                    <WarningOutlined className={'small-avatar-danger'}/>
                                </Tooltip>
                            </span>
                        </div>
                    </React.Fragment>
                )
            })
        },
        {
            title: 'Status',
            dataIndex: 'offer_status',
            width: 132,
            render: ((value: string, row: any) => {
                let area = <span style={{fontSize: '85%'}} className={`font-90`}>{`${row?.area?.toUpperCase()}`}</span>;
                let purcahseMethod = (row?.purchase_method === 'cash') ? <Tag style={{fontSize: "70%", display: "inline"}} color="#f50">Tunai</Tag> : <Tag style={{fontSize: "70%", display: "inline"}} color="#87d068">Kredit</Tag>;
                let status: any = "-";
                if (value?.toUpperCase() === 'OPEN') {
                    status = <Tag style={{fontSize: "70%", display: "inline"}} color="#108ee9">Open</Tag>;
                } else if (value?.toUpperCase() === 'CANCEL') {
                    status = <Tag style={{fontSize: "70%", display: "inline"}} color="#f50">{(row?.cancel_admin_id === 'SYSTEM') ? "Cancel System" : "Cancel"}</Tag>;
                } else if (value?.toUpperCase() === 'ORDER') {
                    status = <Tag style={{fontSize: "70%", display: "inline"}} color="#87d068">Order</Tag>;
                }
                return (<React.Fragment>{area}<br/>{purcahseMethod}{status}</React.Fragment>)
            })
        }, {
            title: 'Tgl Transaksi',
            dataIndex: 'transaction_time',
            width: 140,
            render: ((value: string, row: any) => {
                return (
                    <>
                        <span style={{fontSize: "85%"}} className={`font-90`}>{`${value?.substring(0, 10)}`}</span><br/>
                        <span style={{fontSize: "65%"}} className={`font-90`}>{`${value?.substring(11, 19)}`}</span>
                    </>
                )
            })
        }, {
            title: 'Nama Pemilik',
            dataIndex: 'id_cards',
            width: 120,
            render: ((value: any, row: any) => {
                return (
                    <React.Fragment>
                        <span className={`font-80`}>{`${(value?.full_name?.length < 14) ? value?.full_name?.toUpperCase() : value?.full_name?.toUpperCase()?.substring(0, 12) + "..."}`}</span><br/>
                        <span className={`font-75-grey`}>{`${value?.id_card_number}`}</span>
                    </React.Fragment>
                )
            })
        },
        {
            title: 'Agen | Promo',
            dataIndex: 'agent_code',
            width: 120,
            render: ((value: string, row: any) => {
                return <React.Fragment>
                <span className={`font-80`}>
                    <span style={(!row?.amarta_vip_uid) ? {display: 'none'} : {}}>
                        <Tooltip title={`User AmartaVip ${row?.amarta_vip_uid}`} color={'cyan'}><ThunderboltOutlined style={{fontSize: "110%", fontWeight: "bold", color: "#3d8342", cursor: "help"}}/></Tooltip>&nbsp;
                    </span>

                    {`${(row?.affiliate_code && (row?.affiliate_code !== "NO_DATA")) ? row?.affiliate_code : ""}`}
                    {`${(value && (value !== "NO_DATA")) ? value : ""}`}
                    <br/>
                    <span style={{fontSize: "70%"}}>{row?.promo_codes?.toString()}</span>
                </span>
                </React.Fragment>
            })
        },
        {
            title: 'Product',
            dataIndex: 'variant_name',
            width: 150,
            render: ((value: string, row: any) => {
                return <React.Fragment> <span className={`font-85-red`}>{row?.product?.brand_name}</span><br/><span className={`font-85-grey`}>{row?.product?.model_name}</span></React.Fragment>
            })
        },
        {
            title: 'Sumber',
            dataIndex: 'source',
            width: 180,
            render: ((value: string, row: any) => {
                return (
                    <React.Fragment>
                        <span style={(!row?.amarta_vip_is_lead) ? {display: 'none'} : {}}><Tooltip title={`Konsumen berasal dari LeadAgent`} color={'cyan'}><SolutionOutlined style={{fontSize: "110%", fontWeight: "bold", color: "#3d8342", cursor: "help"}}/></Tooltip>&nbsp;</span>
                        <span className={`font-85-red`}>{`${value}`}</span><br/>
                        <span style={row?.purchase_method === 'cash' ? {display: 'none'} : {}}><span className={`font-75-grey`}>{`${row?.credit?.finco_code?.toUpperCase()}`}</span></span>
                    </React.Fragment>
                )
            })
        },
        {
            title: 'Action',
            key: 'operation',
            fixed: 'right',
            width: 100,
            render: ((row: any) => {
                const items: MenuProps['items'] = [
                    {key: '1', label: (<span onClick={() => this.setState({chosenOfferCode: row.transaction_code, chosenOfferRow: row, showModalDetailOffer: true})}> <SearchOutlined/> Lihat Detail</span>)},
                    {key: '2', label: (<span onClick={() => this.copyToClipboard(`${row.area?.toUpperCase()} | ${(row?.purchase_method === "cash") ? "TUNAI" : "KREDIT | " + row?.credit?.finco_code?.toUpperCase()} | ${row?.id_cards?.owner_full_name?.toUpperCase()} | ${row.transaction_code} | ${row?.product?.model_name?.toUpperCase()}`)}> <CopyOutlined/> Copy Ringkasan</span>)},
                ];
                if (row?.offer_status?.toUpperCase() === "OPEN") {
                    items.push(
                        {key: '3', label: (<span onClick={event => this.setState({chosenOfferCode: row.transaction_code, showModalUpdateOwner: true})} style={{cursor: "pointer"}}> <EditOutlined/> Edit Data Pemilik</span>)},
                        {key: '4', label: (<span onClick={event => this.setState({chosenOfferCode: row.transaction_code, showModalUpdateDoc: true})} style={{cursor: "pointer"}}> <EditOutlined/> Edit Data Dokumen</span>)},
                        {key: '5', label: (<span onClick={event => this.setState({chosenOfferCode: row.transaction_code, chosenOfferRow: row, showModalUpdatePhoneNumber: true})} style={{cursor: "pointer"}}> <EditOutlined/> Edit Nomor Telpon</span>)},
                        {key: '7', label: (<span onClick={event => this.setState({chosenOfferCode: row.transaction_code, showModalUpdateGeneralOffer: true})} style={{cursor: "pointer"}}> <EditOutlined/> Edit Offer</span>)},
                    );
                }
                return <React.Fragment>
                    <span className={`font-90`}>
                        <Dropdown menu={{items}} placement="bottomLeft" arrow>
                          <Button size={"small"} type={"primary"}> <ScheduleOutlined/> Aksi</Button>
                        </Dropdown>
                    </span>
                </React.Fragment>
            })
        }
    ]

    constructor(props: ListGeneralOfferProps & any | any) {
        super(props);
        const finalDealerCode = props.match.params.dealerCode.replace(/-/g, '#');
        const picked = this.uDealer.find((o: { DealerCode: any; }) => o.DealerCode === finalDealerCode);
        const companyCode = picked?.DealerCompany ?? "AMARTA";

        this.initState = {
            processing: false,
            dealerCode: finalDealerCode,
            companyCode: companyCode,
            processingFetchTableData: false,
            dataOffer: [],
            pageSize: 100,
            showModalDetailOffer: false,
            filterStartDate: moment().format('YYYY-MM-DD'),
            filterEndDate: moment().format('YYYY-MM-DD'),
            filterOfferStatus: "Open",
            filterPurchaseMethod: "",
            filterCityGroupCode: "",
            filterCityGroupName: "",
            chosenOfferCode: "",
            chosenOfferRow: {},
            detailOrderCode: "",
            detailOrderModal: false,
            updateOfferModal: false,
            chosenOfferUpdate: {},
            showModalUpdateOwner: false,
            showModalUpdatePhoneNumber: false,
            showModalUpdateGeneralOffer: false,

            searchType: "date",
            searchOfferCode: "",
            searchPoCode: "",
            searchProductCode: "",
            qcShow: false,
            showModalUpdateDoc: false,
        }
        this.state = {...this.initState}
    }

    onCloseEditModal = () => {
        this.setState({
            showModalUpdatePhoneNumber: false,
            showModalUpdateGeneralOffer: false,
            showModalUpdateOwner: false,
            showModalUpdateDoc: false,
            qcShow: false,
        });
        this.fetchOffer();
    }

    showDetailOrder = async (code: any) => {
        this.setState({
            detailOrderCode: code,
            detailOrderModal: true,
        })
    }

    copyResume = async () => {
        if (this.state.dataOffer.length === 0) {
            await navigator.clipboard.writeText("");
            message.info('Tidak ada data yang di copy');
            return;
        }
        let finalText = "";
        for (const row of this.state.dataOffer) {
            finalText += `${row.area?.toUpperCase()} | ${(row?.purchase_method === "cash") ? "TUNAI" : "KREDIT | " + row.credit?.finco_code?.toUpperCase()} | ${row.id_cards?.full_name?.toUpperCase()} | ${row.transaction_code} | ${row.product?.model_name?.toUpperCase()}\n`;
        }

        await navigator.clipboard.writeText(finalText);
        message.info('Resume Berhasil di Copy');
    }

    copyToClipboard = async (data: any) => {
        await navigator.clipboard.writeText(data);
        message.info('Kode Berhasil di Copy');
    }

    onDealerChange = async (data: any) => {
        await this.promisedSetState({
            dataOffer: [],
            dealerCode: data.value,
        });
    }

    fetchOffer = async () => {
        const diffDays = moment(this.state.filterEndDate).diff(moment(this.state.filterStartDate), 'days');
        if (diffDays > 14) {
            message.open({
                type: 'error',
                content: <span>Pencarian Data hanya dapat dilakukan dalam range 14 hari. <br/><br/> jika ingin mencari data januari 2021, tglAwal: 2021-01-01 dan tglAkhir: 2021-01-14 </span>,
                duration: 4,
            });
            return;
        }

        await this.promisedSetState({
            dataOffer: [],
            processingFetchTableData: true,
        });

        const payloadFetch = {
            companyCode: this.state.companyCode,
            area: this.state.filterCityGroupCode,
            status: this.state.filterOfferStatus,
            purchaseMethod: this.state.filterPurchaseMethod,
            startDate: moment(this.state.filterStartDate).format("YYYY-MM-DD"),
            endDate: moment(this.state.filterEndDate).format("YYYY-MM-DD"),
            additionalData: (this.state.filterOfferStatus?.toLowerCase() === 'open' && this.state.filterCityGroupCode) ? "order-policy-stock-payment" : null,
            searchType: this.state.searchType,
            searchOfferCode: this.state.searchOfferCode,
            searchPoCode: this.state.searchPoCode,
            searchProductCode: this.state.searchProductCode,
        }

        await offerGeneralApiService.setToken(this.token);
        await offerGeneralApiService.getOffer(
            payloadFetch
        ).then(async value => {
            let finalData: any = [];
            if (this.state.searchType === "offer_code") {
                const singleData = value.data.data;
                singleData.id_cards = {
                    full_name: singleData?.id_card_owner?.full_name,
                    id_card_number: singleData?.id_card_owner?.id_card_number,
                }
                if (value.data.data?.transaction_code) {
                    finalData = [value.data.data];
                }
            } else {
                finalData = value.data.data;
            }

            finalData.sort((a: any, b: any) => new Date(a.transaction_time).getTime() - new Date(b.transaction_time).getTime());

            await this.promisedSetState({
                dataOffer: finalData,
                processingFetchTableData: false,
            });
        }).catch(async e => {
            await this.promisedSetState({
                dataOffer: [],
                processingFetchTableData: false,
            });
            message.error(e?.toString());
        });
    }

    onChangeTable = (pagination: any, filters: any, sorter: any) => {
        if (pagination?.pageSize) {
            this.setState({
                pageSize: pagination?.pageSize,
            });
        }
    }

    changeSearchType = async (type: string) => {
        await this.promisedSetState({
            searchType: type,
            searchOfferCode: "",
            searchPoCode: "",
            searchProductCode: "",
        });

        if (type === "duplicate_idcard") {
            await this.promisedSetState({
                filterStartDate: moment().subtract(14, 'days').format('YYYY-MM-DD'),
                filterEndDate: moment().format('YYYY-MM-DD'),
                filterOfferStatus: "open",
                filterCityGroupCode: "",
            });
        }
    }

    onFieldChange = <T extends keyof Pick<any, "searchProductCode" | "searchPoCode" | "searchOfferCode" | "filterStartDate" | "filterEndDate" | "filterOfferStatus" | "filterPurchaseMethod">>(target: T, value: any) => {
        const currentState: any = {...this.state};
        switch (target) {
            case "searchProductCode":
                currentState.searchProductCode = value;
                break;
            case "searchPoCode":
                currentState.searchPoCode = value;
                break;
            case "searchOfferCode":
                currentState.searchOfferCode = value;
                break;
            case "filterStartDate":
                currentState.filterStartDate = value;
                break;
            case "filterEndDate":
                currentState.filterEndDate = value;
                break;
            case "filterOfferStatus":
                currentState.filterOfferStatus = value;
                if (value === "qc") {
                    currentState.searchType = "qc";
                } else {
                    currentState.searchType = "date";
                }
                break;
            case "filterPurchaseMethod":
                currentState.filterPurchaseMethod = value;
                break;
        }
        currentState.dataOffer = [];
        this.setState({
            ...currentState,
        });
    }

    onCityGroupChange = (data: any) => {
        this.setState({
            filterCityGroupCode: data.value,
            filterCityGroupName: data.children,
            dataOffer: [],
        });
    }

    buttonQcHit = async () => {
        if (!this.state.chosenOfferRow.id_cards?.id_card_number) {
            return Modal.error({title: 'Proses QC Gagal', content: 'Mohon lengkapi nama, nomor ktp, dan image KTP pemilik'});
        }

        const docOcr = [];
        for (const item of this.state.chosenOfferRow?.document) {
            if (item.type === "ownership") {
                docOcr.push(item.image)
            }
        }

        //if (docOcr.length < 3) {
        // return Modal.error({title: 'Proses QC Gagal', content: 'Mohon lengkapi 3 image BPKB dokumen'});
        //}

        this.promisedSetState({
            showModalDetailOffer: false,
            qcShow: true,
        });
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <MainLayout noPadNoMar={true} onChangeDealer={this.onDealerChange} breadcrumbPath={`Offer`} breadcrumbMenu={`List Offer Loan`} defaultSelectedKeys={['m-list-general-offer']} defaultOpenKeys={['sm-offer']}>
                    <div style={{paddingLeft: 10, paddingRight: 10, paddingBottom: 20}}>
                        <div style={{float: "right", fontSize: "85%", color: "grey"}}>Organization: {this.state.companyCode}</div>
                        <br/>
                        <Form layout={`inline`} style={{marginTop: -3}}>
                            <Form layout={`inline`} style={this.state.searchType === "duplicate_idcard" ? {} : {display: 'none'}}>
                                <Form.Item className={'padTop-10'} style={{width: 260}}>
                                    <i className={`small-text-grey`}>Key</i>
                                    <Input disabled={true} value={`duplicate owner id-card last 2 weeks`}/>
                                </Form.Item>
                            </Form>
                            <Form layout={`inline`} style={this.state.searchType === "offer_code" ? {} : {display: 'none'}}>
                                <Form.Item className={'padTop-10'} style={{width: 230}}>
                                    <i className={`small-text-grey`}>Kode Offer</i>
                                    <Input value={this.state.searchOfferCode} onChange={event => this.onFieldChange("searchOfferCode", event.target.value)} placeholder="Kode Offer"/>
                                </Form.Item>
                            </Form>
                            <Form layout={`inline`} style={this.state.searchType === "po_code" ? {} : {display: 'none'}}>
                                <Form.Item className={'padTop-10'} style={{width: 230}}>
                                    <i className={`small-text-grey`}>Kode PO</i>
                                    <Input value={this.state.searchPoCode} onChange={event => this.onFieldChange("searchPoCode", event.target.value)} placeholder="Kode PO"/>
                                </Form.Item>
                            </Form>
                            <Form layout={`inline`} style={this.state.searchType === "product_code" ? {} : {display: 'none'}}>
                                <Form.Item className={'padTop-10'} style={{width: 230}}>
                                    <i className={`small-text-grey`}>Nomor Polisi</i>
                                    <Input value={this.state.searchProductCode} onChange={event => this.onFieldChange("searchProductCode", event.target.value)} placeholder="Nomor Polisi"/>
                                </Form.Item>
                            </Form>
                            <Form layout={`inline`} style={this.state.searchType === "qc" || this.state.searchType === "date" ? {} : {display: 'none'}}>
                                <Form.Item className={'padTop-10'} style={this.state.searchType !== "qc" ? {width: 150} : {display: 'none'}}>
                                    <i className={`small-text-grey`}>Area</i>
                                    <AreaGroupCitySelect companyCode={this.state.companyCode} onCityGroupChangeProps={this.onCityGroupChange} dealerCode={this.state.dealerCode} value={this.state.filterCityGroupCode}/>
                                </Form.Item>

                                <Form.Item className={'padTop-10'} style={this.state.searchType === "qc" || this.state.searchType === "date" ? {width: 100} : {display: 'none'}}>
                                    <i className={`small-text-grey`}>Status</i>
                                    <Select
                                        showSearch
                                        placeholder="Pilih Status"
                                        optionFilterProp="children"
                                        onChange={value => this.onFieldChange("filterOfferStatus", value)}
                                        value={this.state.filterOfferStatus}
                                    >
                                        <Select.Option key={`open`} value={`open`}>{`Open`}</Select.Option>
                                        <Select.Option key={`cancel`} value={`cancel`}>{`Cancel`}</Select.Option>
                                        <Select.Option key={`qc`} value={`qc`}>{`QC`}</Select.Option>
                                        <Select.Option key={`order`} value={`order`}>{`Order`}</Select.Option>
                                    </Select>
                                </Form.Item>

                                <Form.Item className={'padTop-10'} style={this.state.searchType !== "qc" ? {width: 140} : {display: 'none'}}>
                                    <i className={`small-text-grey`}>Metode</i>
                                    <Select
                                        showSearch
                                        placeholder="Pilih Metide"
                                        optionFilterProp="children"
                                        onChange={value => this.onFieldChange("filterPurchaseMethod", value)}
                                        value={this.state.filterPurchaseMethod}
                                    >
                                        <Select.Option key={`all`} value={``}>{`Semua Metode`}</Select.Option>
                                        <Select.Option key={`cash`} value={`cash`}>{`Tunai`}</Select.Option>
                                        <Select.Option key={`credit`} value={`credit`}>{`Kredit`}</Select.Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item className={'padTop-10'} style={this.state.searchType !== "qc" ? {} : {display: 'none'}}>
                                    <i className={`small-text-grey`}>Tgl Awal</i><br/>
                                    <DatePicker defaultValue={moment(this.state.filterStartDate, 'YYYY-MM-DD')} onChange={event => this.onFieldChange("filterStartDate", event)} format={'YYYY-MM-DD'}/>
                                </Form.Item>
                                <Form.Item className={'padTop-10'} style={this.state.searchType !== "qc" ? {} : {display: 'none'}}>
                                    <i className={`small-text-grey`}>Tgl Akhir</i><br/>
                                    <DatePicker defaultValue={moment(this.state.filterEndDate, 'YYYY-MM-DD')} onChange={event => this.onFieldChange("filterEndDate", event)} format={'YYYY-MM-DD'}/>
                                </Form.Item>

                            </Form>
                            <Form.Item className={'padTop-20'}>
                                <Dropdown.Button
                                    type="primary"
                                    onClick={this.fetchOffer}
                                    icon={<DownOutlined/>}
                                    trigger={['click']}
                                    overlay={(
                                        <Menu>
                                            <Menu.Item key={1} onClick={event => this.changeSearchType("date")}>Pencarian Tanggal</Menu.Item>
                                            <Menu.Item key={2} onClick={event => this.changeSearchType("offer_code")}>Pencarian Kode Offer</Menu.Item>
                                            <Menu.Item key={3} onClick={event => this.changeSearchType("product_code")}>Pencarian Nomor Polisi</Menu.Item>
                                            {/*<Menu.Item key={3} onClick={event => this.changeSearchType("po_code")}>Pencarian Kode PO</Menu.Item>*/}
                                            {/*<Menu.Item key={4} onClick={event => this.changeSearchType("duplicate_idcard")}>Pencarian Duplikat IdCard</Menu.Item>*/}
                                        </Menu>
                                    )}
                                ><SearchOutlined/> Cari Data</Dropdown.Button>
                            </Form.Item>
                        </Form>
                    </div>

                    <div style={{backgroundColor: "#f0f2f5"}}> &nbsp; </div>

                    <Table
                        title={() => <h3 style={{fontWeight: 'bold', fontSize: "110%"}}>Tabel List Offer <Tooltip title="Click untuk copy resume offer" color={'cyan'}><CopyOutlined className={'small-avatar-link'} onClick={event => this.copyResume()}/></Tooltip></h3>}
                        rowKey={'transaction_code'}
                        size={'small'}
                        scroll={{x: 'calc(500px + 50%)'}}
                        loading={this.state.processingFetchTableData}
                        columns={this.tableColumn}
                        dataSource={this.state.dataOffer}
                        pagination={{pageSize: this.state.pageSize}}
                        onChange={this.onChangeTable}
                    />
                </MainLayout>

                <Modal
                    open={this.state.showModalDetailOffer}
                    title={`Detail Offer` + (this.state.chosenOfferRow?.qc_status ? ` (telah di QC)` : "")}
                    onOk={() => this.setState({showModalDetailOffer: false})}
                    onCancel={() => this.setState({showModalDetailOffer: false})}
                    width={'90%'}
                    style={{top: 10}}
                    cancelText={'Tutup'} okText={false}
                    footer={[
                        <Button style={(!this.state.chosenOfferRow?.qc_status) && (this.state.chosenOfferRow?.offer_status === "OPEN") ? {} : {display: 'none'}} key="doQc" type="primary" onClick={this.buttonQcHit}>Lakukan QC</Button>,
                        <Button key="back" type="default" onClick={() => this.setState({showModalDetailOffer: false})}>Tutup</Button>,
                    ]}
                >
                    <DetailGeneralOffer companyCode={this.state.companyCode} offerCode={this.state.chosenOfferCode} time={Math.floor(+new Date() / 1000)}/>
                </Modal>

                <Modal
                    open={this.state.qcShow}
                    title="QC Offer"
                    style={{top: 20}}
                    width={"80%"}
                    onCancel={() => this.setState({qcShow: false})}
                    footer={[]}
                >
                    <QcLoan onCloseUpdateOwnerIdCardProps={this.onCloseEditModal} token={this.token} companyCode={this.state.companyCode} offerCode={this.state.chosenOfferCode} time={Math.floor(+new Date() / 1000)}/>
                </Modal>

                <Modal
                    open={this.state.detailOrderModal}
                    title="Detail Order"
                    onCancel={() => this.setState({detailOrderCode: "", detailOrderModal: false})}
                    footer={[<Button key="1" type="primary" onClick={() => this.setState({detailOrderCode: "", detailOrderModal: false})}>Tutup</Button>]}
                >
                    <DetailOrder dealerCode={this.state.dealerCode} orderCode={this.state.detailOrderCode} time={Math.floor(+new Date() / 1000)}/>
                </Modal>

                <Modal
                    style={{top: 10}}
                    open={this.state.showModalUpdateOwner}
                    title="Update Owner KTP"
                    onCancel={() => this.setState({showModalUpdateOwner: false})}
                    footer={[]}
                >
                    <UpdateOwnerOffer type={`generalOffer`} token={this.token} onCloseUpdateOwnerIdCardProps={this.onCloseEditModal} companyCode={this.state.companyCode} dealerCode={this.state.dealerCode} offerCode={this.state.chosenOfferCode} time={Math.floor(+new Date() / 1000)}/>
                </Modal>

                <Modal
                    style={{top: 10}}
                    open={this.state.showModalUpdateDoc}
                    title="Update Document"
                    onCancel={() => this.setState({showModalUpdateDoc: false})}
                    footer={[]}
                >
                    <UpdateDocumentGeneralOffer type={`generalOffer`} token={this.token} onCloseUpdateOwnerIdCardProps={this.onCloseEditModal} companyCode={this.state.companyCode} dealerCode={this.state.dealerCode} offerCode={this.state.chosenOfferCode} time={Math.floor(+new Date() / 1000)}/>
                </Modal>

                <Modal
                    open={this.state.showModalUpdateGeneralOffer}
                    title={`Update General Offer`}
                    style={{top: 10}}
                    width={'90%'}
                    onCancel={() => this.setState({showModalUpdateGeneralOffer: false})}
                    footer={[]}
                >
                    <UpdateGeneralOffer update_bill={false} onCloseUpdateVehicleAndPromo={this.onCloseEditModal} companyCode={this.state.companyCode} dealerCode={this.state.dealerCode} offerCode={this.state.chosenOfferCode} time={Math.floor(+new Date() / 1000)}/>
                </Modal>

                <Modal
                    open={this.state.showModalUpdatePhoneNumber}
                    style={{top: 10}}
                    title="Update Phone Number"
                    onCancel={() => this.setState({showModalUpdatePhoneNumber: false})}
                    footer={[]}
                >
                    <UpdatePhoneNumber
                        type={`generalOffer`}
                        companyCode={this.state.companyCode}
                        onCloseUpdatePhoneNumberProps={this.onCloseEditModal}
                        offerCode={this.state.chosenOfferCode}
                        time={Math.floor(+new Date() / 1000)}
                        ownerPhoneNumber={this.state.chosenOfferRow?.contact?.phone_number_owner ?? ""}
                        ownerAlternativePhoneNumber={this.state.chosenOfferRow?.owner_alternative_phone_number ?? ""}
                        orderMakerPhoneNumber={this.state.chosenOfferRow?.order_maker_phone_number ?? ""}
                        poPhoneNumber={this.state.chosenOfferRow?.po_phone_number ?? ""}
                    />
                </Modal>
            </React.Fragment>
        );
    }
}

export default (withAuth(withRouter(ListGeneralOffer), 8));